import { getUrlParam } from "@/utils/util";

const FORCE_RELOGIN_FLAG = "__console_force_relogin__";

function hasValidToken(token) {
    return !!token && !["null", "undefined"].includes(token);
}

export const Mixin = {
    data() {
        return {
            active: 0,
            getCustomerCompanyInfoList: [],
            getCustomerAppInfoList: [],
            isSpinning: false,
            companyInfo: {
                companyName: "",
                companyCode: "",
                appUrl: "",
            },
            toLoginFlag: "",
        }
    },
    computed: {
        VUE_APP_LOGO() {
            return "/weiit_logo.png";
        },
        hasStore() {
            return (
                this.getCustomerAppInfoList &&
                this.getCustomerAppInfoList.some((item) => item.appName == "门店")
            );
        },
        hasMall() {
            return (
                this.getCustomerAppInfoList &&
                this.getCustomerAppInfoList.some((item) => item.appName == "商城")
            );
        },
    },

    methods: {
        clearAuthCache() {
            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            localStorage.removeItem("userId");
        },
        async initData(callback) {
            try {
                await this.getCustomerCompanyInfo();
                await this.getCustomerAppInfo();
                if (callback) callback()
            } catch (error) {
                console.error("initData error:", error);
                this.spinning = false;
                throw error;
            }
        },
        getToken() {
            const urlToken = getUrlParam("token");
            if (hasValidToken(urlToken)) {
                localStorage.setItem("token", encodeURI(urlToken));
                sessionStorage.removeItem(FORCE_RELOGIN_FLAG);
                history.pushState({}, 0, this.delUrlParam("token"));
            } else {
                const forceRelogin = sessionStorage.getItem(FORCE_RELOGIN_FLAG) === "1";
                if (forceRelogin) {
                    this.clearAuthCache();
                    location.href = process.env.VUE_APP_LOGIN_BASE_URL;
                    return;
                }
                const token = localStorage.getItem("token");
                if (!hasValidToken(token)) {
                    this.clearAuthCache();
                    location.href = process.env.VUE_APP_LOGIN_BASE_URL;
                }
            }
        },
        getUrl(hasType, type) {
            let info = this.getCustomerAppInfoList.find(
                (item) => type == item.appName
            );
            let url = this.getCustomerAppInfoList
                .find((item) => type == item.appName)
                .appUrl.replace("#rcsToken#", info.ticket)
                .replace("#tenantId#", info.tenantId);
            if (process.env.NODE_ENV == "development") {
                //本地要跳本地的商城和门店
                if (url.includes("https://store.wei-it.com")) {
                    //门店
                    url = url.replace(
                        "https://store.wei-it.com",
                        process.env.VUE_APP_STORE_URL
                    );
                } else {
                    //商城
                    url = url.replace(
                        "https://mall.wei-it.com",
                        process.env.VUE_APP_MALL_URL
                    );
                }
            }
            return hasType ? url : "";
        },
        toGo() {
            let url = "";
            switch (this.active) {
                case 1:
                    url = this.getUrl(this.hasStore, "门店");
                    url && (location.href = url);
                    break;
                case 2:
                    url = this.getUrl(this.hasMall, "商城");
                    url && (location.href = url);
                    break;
                default:
                    break;
            }
        },
        //获取当前用户关联的企业列表
        async getCustomerCompanyInfo() {
            let getCustomerCompanyInfo = await this.$axios.post(
                this.$api.getCustomerCompanyInfo
            );
            this.getCustomerCompanyInfoList =
                getCustomerCompanyInfo.result &&
                    getCustomerCompanyInfo.result.length > 0
                    ? getCustomerCompanyInfo.result
                    : [];
            this.companyInfo =
                getCustomerCompanyInfo.result &&
                    getCustomerCompanyInfo.result.length > 0
                    ? getCustomerCompanyInfo.result[0]
                    : {};
        },
        //根据企业编号获取当前用户关联的应用列表
        async getCustomerAppInfo() {
            let data = {
                companyCode: this.companyInfo.companyCode,
            };
            let getCustomerAppInfo = await this.$axios.post(
                this.$api.getCustomerAppInfo,
                data
            );
            this.getCustomerAppInfoList = getCustomerAppInfo.result;
            this.spinning = false;
            this.displayNone = false;
        },
    }

}
